export default function SaveIndicator({ status, "data-testid": tid = "save-indicator" }) {
  const map = {
    idle: { text: "", cls: "opacity-0" },
    saving: { text: "Saving…", cls: "text-silver" },
    saved: { text: "Saved \u2713", cls: "text-green-400" },
    error: { text: "Save failed — retrying…", cls: "text-red-400" },
  };
  const m = map[status] || map.idle;
  return (
    <span className={`text-xs transition-opacity ${m.cls}`} data-testid={tid} data-save-status={status}>{m.text}</span>
  );
}
